import { format, isValid, parseISO } from 'date-fns';

const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (!isValid(date)) return '';
  return format(date, 'yyyy-MM-dd HH:mm');
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (!isValid(date)) return '';
  return format(date, 'yyyy-MM-dd');
};

export { formatDate, formatDateTime };
